//
// calculate and update the step numbers of the hardship form headers
//

var displayFormSteps = (function () {
    'use strict';

    // selectors
    let formSectionSelector = "form div[data-sf-role='separator']";
    var currentPageSelector = "span[section-role='counter']";
    var totalPagesSelector = "span[section-role='total']";
    var prevButtonSelector = "[data-sf-btn-role='prev']";
    var nextButtonSelector = "[data-sf-btn-role='next']";
    var coborrowerRadioSelector = "input[name^='coborrower_status']";
    let formContainer = '[data-sf-role="form-container"]';
    var pageHeadingSelector = ".section-heading";
    let pagesCount = 0;
    let currentPage = 0;
    const optionalPagesInitial = 3;
    let optionalPages = optionalPagesInitial;
    const optionalPagesInBusinessPath = 4;
    const businessPages = 7;
    let totalDisplayPages = 0;
    let totalDisplayPagesCoBorrower = 0;

    function updateHeaderValues(currentCount, totalCount) {
        $(currentPageSelector).text(currentCount);
        $(totalPagesSelector).text(totalCount);
    }

    function scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

    $(formContainer).on("form-page-changed", function (e, index, previousIndex) {
        scrollToTop();
        var currentHeading = $(`${pageHeadingSelector}:visible`);
        $(pageHeadingSelector).attr("tabindex", "-1");
        currentHeading.attr("tabindex", "").append("<span class='heading-dot'>.</span>");
        
        setTimeout(function () { $(".heading-dot").remove(); }, 300);
    });
        
    $(nextButtonSelector).on("click", calculatePagesCount);

    var pathInputsSelector = "[name^='path_']";

    function getCurrentPath() {
        var pathInputs = $(`${pathInputsSelector}:checked`);
        var yesCount = 0;

        for (var pathInput of pathInputs.toArray()) {
            if ($(pathInput).val() == "Yes") {
                yesCount++;
            }
        }

        return yesCount == 3 ? "Business" : "Consumer";
    }

    //get the pagesCount based on whether first page is skipped, then search for 'Submit'
    function calculatePagesCount() {
        //if we calculate totlaDisplayPages only once a bug is introduced where pages don't get counter appropriately if we go back and change the path

        //business path taken
        if (getCurrentPath() == "Business") {
            $(formSectionSelector).each(function (index, el) {
                if ($(el).has('.sf-SubmitButton').length) {
                    pagesCount = index - 1;
                    //no optional pages
                    let noOptionalDisplayPages = pagesCount - optionalPagesInBusinessPath;

                    totalDisplayPages = (totalDisplayPagesCoBorrower != 0 && totalDisplayPagesCoBorrower != noOptionalDisplayPages) ? totalDisplayPagesCoBorrower : noOptionalDisplayPages;
                    return false;
                }
            });
        }
        //consumer path taken
        else {
            pagesCount = $(formSectionSelector).length;
            //count total pages
            totalDisplayPages = pagesCount - (optionalPages + businessPages);
        }
        // set the initial text of the headers
        updateHeaderValues(currentPage, totalDisplayPages);
    }

    function init() {
        // global variables
        let changeCounter = 0;

        // update the text on prev/next
        $(prevButtonSelector).on("click", function () {

            currentPage--;
            updateHeaderValues(currentPage, totalDisplayPages);
        });

        const callBack = function (mutationsList, observer) {
            let nextAll = $(mutationsList[0].target).nextAll("div[data-sf-role='separator']");
            for (let next of nextAll.toArray()) {
                if ($(next).css("display") != "none") {
                    currentPage++;
                    updateHeaderValues(currentPage, totalDisplayPages);
                    break;
                }
            }

            observer.disconnect();
        };

        const observer = new MutationObserver(callBack);

        $(nextButtonSelector).on('click', function () {
            var element = $(this);
            while (element.attr("data-sf-role") != "separator") {
                element = element.parent();
            }

            const config = { attributes: true, childList: false, subtree: false };

            observer.observe(element[0], config);
        });

        // change totalDisplayPages value for the optional page

        $(coborrowerRadioSelector).on('change', function () {
            changeCounter++;
            var radioValue = $(this).val();
            if (radioValue.toLowerCase().includes("yes")) {
                totalDisplayPages += optionalPages - 1;
                optionalPages = 0;
                totalDisplayPagesCoBorrower = totalDisplayPages;
            } else if (radioValue.toLowerCase().includes("no") && (changeCounter > 1)) {
                optionalPages = optionalPagesInitial;
                totalDisplayPages -= optionalPages;
                totalDisplayPagesCoBorrower = 0;
            }
            calculatePagesCount();
        });
    }

    // check if selectors are loaded
    if (document.querySelectorAll(formSectionSelector).length) {
        init();
    }
})();
